import { httpRequest } from 'http'

export const UNIT_PARTICIPANTS_REQUEST = 'unit_participants/REQUEST'
export const UNIT_PARTICIPANTS_SUCCESS = 'unit_participants/SUCCESS'
export const UNIT_PARTICIPANTS_ERROR = 'unit_participants/ERROR'


export function startRequest() {
    return {
        type: UNIT_PARTICIPANTS_REQUEST,
        payload: {},
    }
}

export function requestSuccess(participants, unitServerId, peripheryId) {
    return {
        type: UNIT_PARTICIPANTS_SUCCESS,
        payload: { participants, unitServerId, peripheryId },
    }
}

export function requestError(errorData) {
    return {
        type: UNIT_PARTICIPANTS_ERROR,
        payload: errorData,
    }
}

export function requestUnitParticipants(unitServerId, peripheryId) {
    return async (dispatch) => {
        dispatch(startRequest())
        try {
            const url = `/game_api/units/${unitServerId}/${peripheryId}/participants`
            const participants = await httpRequest(url)
            dispatch(requestSuccess(participants, unitServerId, peripheryId))
        } catch (error) {
            dispatch(requestError(error))
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/unit_participants.js